import { useMemo } from 'react'
import { AuthCookiesService } from '@/services'
import { ExecutionEnvironment } from '@/utils/ExecutionEnvironment'
import { getTokenInfo } from '@/utils/helpers'

type Permission = string

export const useAuthPermissions = () => {
  const token = ExecutionEnvironment.isSsr ? '' : AuthCookiesService.getJwt()

  return useMemo(() => {
    const payloadPermissions = getTokenInfo(token)?.payload?.permissions

    const permissions = Array.isArray(payloadPermissions) ? payloadPermissions.map<Permission>(permission => String(permission)) : []
    const permissionsSet = new Set<Permission>(permissions)

    return {
      permissions,
      hasPermission: (permission: Permission) => permissionsSet.has(permission),
    }
  }, [token])
}
